import type { IPriceRangeCalculationStrategy } from "./interfaces"
import { CustomRangeCalculationStrategy } from "./custom-range-calculation-strategy"
import { FullRangeCalculationStrategy } from "./full-range-calculation-strategy"

/**
 * Factory for creating price range calculation strategies
 * Follows the same pattern as VoteOptimizationStrategyFactory
 */
export class PriceRangeCalculationStrategyFactory {
  /**
   * Create a strategy instance based on whether full range is selected
   * @param fullRange - Whether to use full range strategy
   * @returns Appropriate strategy implementation
   */
  static create(fullRange: boolean): IPriceRangeCalculationStrategy {
    if (fullRange) {
      return new FullRangeCalculationStrategy()
    }
    return new CustomRangeCalculationStrategy()
  }
}
